import { useEffect } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { useRecoilValue, RecoilRoot } from 'recoil';

import { authAtom, initClassAtom } from '_state';
import { Login, PasswordRecover, ResetPassword } from './';

export { Account };

function Account({ history, match }) {
    const auth = useRecoilValue(authAtom);
    const classPicked = useRecoilValue(initClassAtom);
    const location = useLocation();
    const { path } = match;

    useEffect(() => {
        // Allow reset password link to work even if authenticated
        const isResetPasswordPage = location.pathname.includes('resetpassword');
        if (auth && !isResetPasswordPage) history.push('/');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth, location.pathname]);

    return (
        <Switch>
            <Route path={`${path}/login`} component={Login} />
            <Route path={`${path}/passwordrecover`} component={PasswordRecover} />
            <Route path={`${path}/resetpassword`} component={ResetPassword} />
            <Redirect to={`${path}/login`} />
        </Switch>
    );
}
